import axios from 'axios';

export function getJobsFromBoard(params) {
  return axios.get(`https://boards-api.greenhouse.io/v1/boards/${params.boardName}/jobs?content=true`);
}

export function getJobsFromPuckBoard(params) {
  return axios.get(`https://api.careerpuck.com/v1/public/job-boards/${params.boardName}/greenhouse?content=true`);
}

export function getJobDetailsFor(params) {
  return axios.get(`https://boards-api.greenhouse.io/v1/boards/${params.boardName}/jobs/${params.jobId}`);
}
